<div class="overview-card">
        
    <!-- Header Section -->
    <div class="card-header">
        <div class="header-title-group">
            <h2>Client & Opportunity Overview</h2>
        </div>

       <!-- Top Tab Controls -->
        <!-- <div class="tab-controls">
            <button class="tab-btn" [ngClass]="{'active': selected_tab == 'Graph'}" (click)="changeTab('Graph')">Graph</button>
            <button class="tab-btn" [ngClass]="{'active': selected_tab == 'Hybrid'}" (click)="changeTab('Hybrid')">Hybrid</button>
        </div> -->
    </div>

    <ng-container *ngIf="client_opportunity_overview_loaded">
        <ng-container *ngIf="selected_tab == 'Graph'">
            <!-- Table Header & Axis Labels -->
            <div class="table-header">
                <div class="col-segment">Segment</div>
                <div class="col-axis">
                    <span>0</span>
                    <span>25</span>
                    <span>50</span>
                    <span>75</span>
                    <span>100</span>
                </div>
                <!-- <div class="col-metrics-header">Clients &nbsp;·&nbsp; Value</div> -->
                <div class="col-metrics-header">
                    <div>Clients</div>
                    <div style="width: 100px;">Value</div>
                </div>
            </div>

            <!-- Segments List Container with Pure CSS Hover Interaction -->
            <div class="segments-container">
                <!-- Background Grid Lines -->
                <div class="grid-lines">
                    <div class="grid-line"></div>
                    <div class="grid-line"></div>
                    <div class="grid-line"></div>
                    <div class="grid-line"></div>
                    <div class="grid-line"></div>
                </div>

                <!-- Row 1: Actively Managed -->
                <div class="segment-row">
                    <div class="col-segment">
                        <!-- Inline SVG Dot -->
                        <svg class="dot-svg" width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#059669"/></svg>
                        <span class="segment-name">Actively Managed</span>
                    </div>
                    <div class="col-bar">
                        <div class="progress-track">
                            <div class="progress-fill" [style.background]="'#059669'" [style.width]="client_opportunity_overview['am_percentage'] + '%'"></div>
                        </div>
                        <span class="percentage">{{client_opportunity_overview['am_percentage']}}%</span>
                    </div>
                    <div class="col-metrics">
                        <span class="client-count">{{commonService.abbreviateNumber(client_opportunity_overview['am_count'])}}</span>
                        <span class="client-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{commonService.abbreviateNumber(client_opportunity_overview['am_aum'])}}</span>
                    </div>
                </div>

                <!-- Row 2: High Value -->
                <div class="segment-row">
                    <div class="col-segment">
                        <svg class="dot-svg" width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#3b82f6"/></svg>
                        <span class="segment-name">High Value</span>
                    </div>
                    <div class="col-bar">
                        <div class="progress-track">
                            <div class="progress-fill" [style.background]="'#3b82f6'" [style.width]="client_opportunity_overview['hv_percentage'] + '%'"></div>
                        </div>
                        <span class="percentage">{{client_opportunity_overview['hv_percentage']}}%</span>
                    </div>
                    <div class="col-metrics">
                        <span class="client-count">{{commonService.abbreviateNumber(client_opportunity_overview['hv_count'])}}</span>
                        <span class="client-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{commonService.abbreviateNumber(client_opportunity_overview['hv_aum'])}}</span>
                    </div>
                </div>

                <!-- Row 3: Low Value -->
                <div class="segment-row">
                    <div class="col-segment">
                        <svg class="dot-svg" width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#a855f7"/></svg>
                        <span class="segment-name">Low Value</span>
                    </div>
                    <div class="col-bar">
                        <div class="progress-track">
                            <div class="progress-fill" [style.background]="'#a855f7'" [style.width]="client_opportunity_overview['lv_percentage'] + '%'"></div>
                        </div>
                        <span class="percentage">{{client_opportunity_overview['lv_percentage']}}%</span>
                    </div>
                    <div class="col-metrics">
                        <span class="client-count">{{commonService.abbreviateNumber(client_opportunity_overview['lv_count'])}}</span>
                        <span class="client-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{commonService.abbreviateNumber(client_opportunity_overview['lv_aum'])}}</span>
                    </div>
                </div>

                <!-- Row 4: Future Value -->
                <div class="segment-row">
                    <div class="col-segment">
                        <svg class="dot-svg" width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#d97706"/></svg>
                        <span class="segment-name">Future Value</span>
                    </div>
                    <div class="col-bar">
                        <div class="progress-track">
                            <div class="progress-fill" [style.background]="'#d97706'" [style.width]="client_opportunity_overview['fv_percentage'] + '%'"></div>
                        </div>
                        <span class="percentage">{{client_opportunity_overview['fv_percentage']}}%</span>
                    </div>
                    <div class="col-metrics">
                        <span class="client-count">{{commonService.abbreviateNumber(client_opportunity_overview['fv_count'])}}</span>
                        <span class="client-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{commonService.abbreviateNumber(client_opportunity_overview['fv_aum'])}}</span>
                    </div>
                </div>

                <!-- Row 5: Future Risk -->
                <div class="segment-row">
                    <div class="col-segment">
                        <svg class="dot-svg" width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#f43f5e"/></svg>
                        <span class="segment-name">Future Risk</span>
                    </div>
                    <div class="col-bar">
                        <div class="progress-track">
                            <div class="progress-fill" [style.background]="'#f43f5e'" [style.width]="client_opportunity_overview['fr_percentage'] + '%'"></div>
                        </div>
                        <span class="percentage">{{client_opportunity_overview['fr_percentage']}}%</span>
                    </div>
                    <div class="col-metrics">
                        <span class="client-count">{{commonService.abbreviateNumber(client_opportunity_overview['fr_count'])}}</span>
                        <span class="client-value">{{APP_CONSTANTS.CURRENCY_SYMBOL}} {{commonService.abbreviateNumber(client_opportunity_overview['fr_aum'])}}</span>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="selected_tab == 'Hybrid'">
            <div class="dashboard-card">
                <!-- Left Column: Concentric Rings Chart -->
                <div class="chart-container">
                    <svg class="concentric-ring-svg" viewBox="0 0 200 200">
                        <!-- Background Tracks -->
                        <circle class="track" cx="100" cy="100" r="85" />
                        <circle class="track" cx="100" cy="100" r="70" />
                        <circle class="track" cx="100" cy="100" r="55" />
                        <circle class="track" cx="100" cy="100" r="40" />
                        <circle class="track" cx="100" cy="100" r="25" />

                        <!-- 1. Actively Managed (r = 85) -->
                        <circle class="hybrid-progress-ring ring-green" cx="100" cy="100" r="85"
                                [style.stroke-dasharray]="calculateCircularProgress(client_opportunity_overview.am_percentage, 85).strokeDasharray"
                                [style.stroke-dashoffset]="calculateCircularProgress(client_opportunity_overview.am_percentage, 85).strokeDashoffset" />
                        
                        <!-- 2. High Value (r = 70) -->
                        <circle class="hybrid-progress-ring ring-blue" cx="100" cy="100" r="70"
                                [style.stroke-dasharray]="calculateCircularProgress(client_opportunity_overview.hv_percentage, 70).strokeDasharray"
                                [style.stroke-dashoffset]="calculateCircularProgress(client_opportunity_overview.hv_percentage, 70).strokeDashoffset" />
                        
                        <!-- 3. Low Value (r = 55) -->
                        <circle class="hybrid-progress-ring ring-purple" cx="100" cy="100" r="55"
                                [style.stroke-dasharray]="calculateCircularProgress(client_opportunity_overview.lv_percentage, 55).strokeDasharray"
                                [style.stroke-dashoffset]="calculateCircularProgress(client_opportunity_overview.lv_percentage, 55).strokeDashoffset" />
                        
                        <!-- 4. Future Value (r = 40) -->
                        <circle class="hybrid-progress-ring ring-orange" cx="100" cy="100" r="40"
                                [style.stroke-dasharray]="calculateCircularProgress(client_opportunity_overview.fv_percentage, 40).strokeDasharray"
                                [style.stroke-dashoffset]="calculateCircularProgress(client_opportunity_overview.fv_percentage, 40).strokeDashoffset" />
                        
                        <!-- 5. Future Risk (r = 25) -->
                        <circle class="hybrid-progress-ring ring-red" cx="100" cy="100" r="25"
                                [style.stroke-dasharray]="calculateCircularProgress(client_opportunity_overview.fr_percentage, 25).strokeDasharray"
                                [style.stroke-dashoffset]="calculateCircularProgress(client_opportunity_overview.fr_percentage, 25).strokeDashoffset" />
                    </svg>
                </div>

                <!-- Right Column: Segment List / Table -->
                <div class="segments-list">
                    
                    <!-- Row 1: Actively Managed -->
                    <div class="hybrid-segment-row">
                        <div class="segment-label">
                            <span class="indicator-bar bar-green"></span>
                            <span class="label-text">Actively Managed</span>
                        </div>
                        <div class="segment-stats">
                            <span class="clients-count">301</span>
                            <span class="value-amount">₹2.9 Cr</span>
                            <span class="percentage text-green">40.68%</span>
                        </div>
                    </div>

                    <!-- Row 2: High Value -->
                    <div class="hybrid-segment-row">
                        <div class="segment-label">
                            <span class="indicator-bar bar-blue"></span>
                            <span class="label-text">High Value</span>
                        </div>
                        <div class="segment-stats">
                            <span class="clients-count">69</span>
                            <span class="value-amount">₹1.3 Cr</span>
                            <span class="percentage text-blue">9.32%</span>
                        </div>
                    </div>

                    <!-- Row 3: Low Value -->
                    <div class="hybrid-segment-row">
                        <div class="segment-label">
                            <span class="indicator-bar bar-purple"></span>
                            <span class="label-text">Low Value</span>
                        </div>
                        <div class="segment-stats">
                            <span class="clients-count">84</span>
                            <span class="value-amount">₹14.7 L</span>
                            <span class="percentage text-purple">11.35%</span>
                        </div>
                    </div>

                    <!-- Row 4: Future Value -->
                    <div class="hybrid-segment-row">
                        <div class="segment-label">
                            <span class="indicator-bar bar-orange"></span>
                            <span class="label-text">Future Value</span>
                        </div>
                        <div class="segment-stats">
                            <span class="clients-count">449</span>
                            <span class="value-amount">₹4.4 Cr</span>
                            <span class="percentage text-orange">60.68%</span>
                        </div>
                    </div>

                    <!-- Row 5: Future Risk -->
                    <div class="hybrid-segment-row">
                        <div class="segment-label">
                            <span class="indicator-bar bar-red"></span>
                            <span class="label-text">Future Risk</span>
                        </div>
                        <div class="segment-stats">
                            <span class="clients-count">91</span>
                            <span class="value-amount">₹1.7 Cr</span>
                            <span class="percentage text-red">12.3%</span>
                        </div>
                    </div>

                </div>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!client_opportunity_overview_loaded">
        <app-loader [loading_text]="'Loading'"></app-loader>
    </ng-container>

</div>